import React from 'react'
import { TTypographyProps } from './type'
import { colors } from '../Colors'
import { Typo } from './styled.css'

const Typography = React.forwardRef<any, TTypographyProps>(
    (
        {
            children,
            variant = 'p',
            name = 'paragraph',
            size = 'large',
            className,
            style,
            fontFamily = 'Inter',
            color = colors.primary[0],
            ...rest
        },
        ref
    ) => {
        return (
            <Typo
                ref={ref}
                style={{ ...style }}
                className={className}
                as={variant}
                name={name}
                size={size}
                color={color}
                fontFamily={fontFamily}
                {...rest}
            >
                {children}
            </Typo>
        )
    }
)

export { TTypographyProps }
export default Typography
